var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.item.click === undefined ? 'headerDefault' : 'headerDefaultPointer',style:(_vm.item.style),on:{"click":function($event){_vm.item.click === undefined ? '' : _vm.item.click($event, _vm.item)}}},[_c('span',[_vm._v("\n      "+_vm._s(_vm.item.keyTitle)+"\n    ")]),_c('div',{staticClass:"hover"},[_vm._v("\n    ↑↓\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }